import moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getClinicsByOrgId } from "../../api/orgnizations";
import { decryptData } from "../../utils/helper";
import { failed } from "../../utils/Tostify";
import "./Organization.css";
import organization_icon from "../../assets/images/insight-admin.svg";
import Search from "../../components/InputFields/Search";
import AddClinic from "./AddClinic";
import { useLocation } from "react-router-dom";
import { sideTabs } from "./Constant";
import Loader from "../../components/Loader/Loader";
import CustomPagination from "../../components/Pagination/CustomPagination";

function Cliniclisting() {
  let token = useSelector((state) => state.userReducer.token);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [clinicData, setClinicData] = useState({
    items: [],
    currentPage: 1,
    totalPages: 1,
    totalItems: 0
  });
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [fromOrgStep, setFromOrgStep] = useState(true);
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" }); // Sorting state
  const location = useLocation();
  const fromEdit = location.state.fromEdit;
  const [fromEditModal, setFromEdit] = useState(true);
  const orgId = location.state?.orgData?._id;
  const ActiveStep = location?.state?.ActiveStep;
  const orgData = location.state?.orgData;
  const fromListing = location.state.fromListing;
  const orgValues = location.state.orgValues;
  const orgLogo  = location.state.logoUrl;

  const getClinicList = async ({page = 1, limit = 10, searchKey = "", orgId}) => {
    let res = "";
    try {
      setIsLoading(true);
      setSearch(searchKey);
      res = await getClinicsByOrgId({
        dispatch,
        token,
        page,
        limit,
        searchKey,
        orgId
      });
      const responseData = decryptData(res?.data);
      if (res?.status === "SUCCESS") {
        setClinicData(responseData);
        setIsLoading(false);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  const handlePagination = (page) => {
    getClinicList({page, limit: 10, searchKey:"", orgId: orgId});
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
        direction = "desc";
    }
    setSortConfig({ key, direction });
};

  const sortData = (data) => {
      if (!sortConfig.key) return data;
      return [...data].sort((a, b) => {
          let aValue = a[sortConfig.key];
          let bValue = b[sortConfig.key];
          // Special case for sorting the Admin field, which is nested
          if (sortConfig.key === "admin") {
              aValue = a.contact?.[0]?.name || ""; // If contact[0] or name is undefined, use an empty string
              bValue = b.contact?.[0]?.name || "";
          }
          // Special case for sorting the Address field, which is nested
          if (sortConfig.key === "address") {
              aValue = (a?.address?.[0]?.city + "," + a?.address?.[0]?.state || "").toLowerCase();
              bValue = (b?.address?.[0]?.city + "," + b?.address?.[0]?.state || "").toLowerCase();
          } else {
              // Convert values to lowercase for case-insensitive sorting
              aValue = (aValue || "").toLowerCase();
              bValue = (bValue || "").toLowerCase();
          }
          if (aValue < bValue) {
              return sortConfig.direction === "asc" ? -1 : 1;
          }
          if (aValue > bValue) {
              return sortConfig.direction === "asc" ? 1 : -1;
          }
          return 0;
      });
  };

  const filteredAndSortedData = sortData(clinicData?.items);

  useEffect(() => {
    if(localStorage.getItem("orgId")){
      getClinicList({page: clinicData?.currentPage, limit: 10, searchKey:"", orgId: localStorage.getItem("orgId")});
    }
  }, []);

  const handleUserBtn = () => {
    navigate("/super-admin/userslist", { state: { ActiveStep: 3, orgData: { _id : localStorage.getItem("orgId"), orgName: orgValues?.orgName }, fromEdit: fromEdit } });
  };

  return (
    <Fragment>
      {isLoading && <Loader />}
      {showModal && (<AddClinic  refetch={(orgId) => getClinicList({orgId})} setShowModal={() => {setShowModal(!showModal);  setFromEdit(false);}}  orgValues={orgValues} fromListing={fromListing} fromOrgStep={fromOrgStep} setFromEdit={setFromEdit} />)}
      <div className="admin_application_container organization_blk pagination_space organization_table p-4 clinic_listing_container">
        <div className="d-flex justify-content-between align-items-center main-header-block header-bg">
          <div className="left_header d-flex align-items-center gap-2">
            <img src={organization_icon} alt="organization_icon" />
            <h2 className="home-title">Organizations</h2>
          </div>
          <div className="right_header_block d-flex justify-content-between align-items-center flex-wrap">
            <div className="right_header d-flex align-items-center">
              <Search
                value={search}
                onChange={(e) => {
                  getClinicList({page: null, limit: null, searchKey: e.target.value.toLowerCase(), orgId: orgId});
                }}
              />
            </div>
          </div>
        </div>
        <div className="mt-4 mb-4 d-flex justify-content-between align-items-center gap-2 flex-wrap">
             <div className="d-flex gap-2 align-items-center">
                <img src={orgLogo} alt="logo" className="img_profile_one" />
                <h3>{orgData?.name || orgValues?.orgName}</h3>
              </div>
              <div className="d-flex flex-column align-items-end">
          {clinicData?.items?.length <= 0 ? <h6 className="quick_note">Quick Tip: <span>Add atleast one hospital location to create organization.</span></h6> : null}
        </div>
        </div>
        <div className="d-flex gap-3 clinic_list">
          <div className="sidebar_container">
            {sideTabs({ ActiveStep, fromEdit, navigate, orgData })}
          </div>
          <div className="sidetab_body">
            <div className="table_space p-0">
              <div className="table-responsive">
                <table>
                  <thead>
                    <tr className="header_table">
                      <th ></th>
                      <th onClick={() => handleSort("name")}>Name<i className='fas fa-sort'></i></th>
                      <th onClick={() => handleSort("admin")}>Primary Contact<i className='fas fa-sort'></i></th>
                      <th>Created</th>
                      <th>Status </th>
                      <th onClick={() => handleSort("address")}>Location<i className='fas fa-sort'></i></th>
                      <th>Phone</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  {filteredAndSortedData?.length > 0 ?
                    filteredAndSortedData?.map((clinic) => (
                      <tbody key={clinic?._id}>
                        <tr><td colSpan="9" height="5" className="bg_light"></td></tr>
                        <tr className="onclick_data" key={clinic?._id}>
                          <td></td>
                          <td>{clinic?.name}</td>
                          <td>{clinic?.contact?.[0]?.name}</td>
                          <td>{moment(clinic?.createdAt).format("MMM-DD-YYYY")}</td>
                          <td><div className={clinic?.active === true ? "active_block_btn" : "not_active_btn"}>{clinic?.active === true ? "Active" : "Not Active"}</div></td>
                          <td>{clinic?.address?.[0]?.city + "," + clinic?.address?.[0]?.state}</td>
                          <td>{"+" + clinic?.telecom?.find((obj) => obj?.system === "phone")?.value}</td>
                          <td></td>
                          <td></td>
                        </tr>
                      </tbody>
                    )) : <tr><td colSpan={10}><p className="text-center">No Data Found</p></td></tr>}
                </table>
              </div>
              <CustomPagination tableData={clinicData?.items} totalPages={clinicData?.totalPages} totalRows={clinicData?.totalItems} rowsPerPage={10} page={clinicData?.items?.length > 0 ? clinicData?.currentPage : 0} handlePage={handlePagination} />
              <div className="d-flex justify-content-between mt-3 gap-3 flex-wrap">
              <button className="save_btn"
              style={{
                  backgroundColor: clinicData?.items?.length <= 0 ? "lightgrey" : null, // Replace #primaryColor with your desired color when enabled
                  cursor: clinicData?.items?.length <= 0 ? "not-allowed" : "pointer", // Optional: change cursor when disabled
                  color: clinicData?.items?.length <= 0 ? "white" : null, // Optional: change text color when disabled
                  border: clinicData?.items?.length <= 0 ? "none" : null // Optional: change border when disabled
                }}
                 disabled={clinicData?.items?.length <= 0}
                 onClick={() => navigate("/super-admin/organization")}>Save & Finish</button>
                 <button className="add_hospital" onClick={() => {setShowModal(true); setFromOrgStep(false);}}>Add Hospital</button>
                <div className="d-flex gap-3">
                  <button
                    className="save_btn"
                    type="submit"
                    style={{
                      backgroundColor: clinicData?.items?.length <= 0 ? "lightgrey" : null, // Replace #primaryColor with your desired color when enabled
                      cursor: clinicData?.items?.length <= 0 ? "not-allowed" : "pointer", // Optional: change cursor when disabled
                      color: clinicData?.items?.length <= 0 ? "white" : null, // Optional: change text color when disabled
                      border: clinicData?.items?.length <= 0 ? "none" : null // Optional: change border when disabled
                    }}
                    disabled={clinicData?.items?.length <= 0}
                    onClick={handleUserBtn}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment >
  );
}

export default Cliniclisting;
